import { TimelineItem } from './TimelineItem';
import { TimelineRoot } from './TimelineRoot';

export const Timeline = {
  Root: TimelineRoot,
  Item: TimelineItem,
};
